import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ReprogramParams } from "../../../domain/entities/reschedule";
import { type ReschedulesDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const reprogram = createAsyncThunk<
  void,
  ReprogramParams,
  { dispatch: ReschedulesDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.REPROGRAM, async (params, { extra }) => {
  await extra.reschedulesRepo.reprogram(params);
});
